import { Injectable } from '@angular/core';
import { FuseNavigationItem } from '@fuse/components/navigation';
import { Admin } from 'app/model';

@Injectable({
  providedIn: 'root',
})
export class NavigationHelper {
  /** Add item to the nav list, after the "my jobs" entry.  @see src\app\mock-api\common\navigation\data.ts */
  addJobNavitem(job: Admin, nav: FuseNavigationItem[]): void {
    // check if job is already in the nav
    let jobItem = nav.find((n) => n.id === `jobs.${job.adminId}`);

    if (!jobItem) {
      // job is not already in the nav, so we need to add it

      // create nav item for this job
      jobItem = {
        id: 'jobs.{jobId}',
        title: '{jobCode}',
        type: 'basic' as any,
        icon: 'heroicons_outline:briefcase',
        link: '/apps/job/{jobId}/corporate',
      };

      this.replaceJobInfo(job, [jobItem]);

      // place new item right after job home
      const pos = nav.findIndex((n) => n.id === 'job-home');
      if (pos >= 0) {
        nav.splice(pos + 1, 0, jobItem);
      }
    }
  }

  /** return tree of navigation items specific to a job; for job container top nav */
  getJobNav(job: Admin, includeGroupHeader: boolean = false): FuseNavigationItem[] {
    const nav = this.getJobNavTemplate(includeGroupHeader);
    this.replaceJobInfo(job, nav);
    return nav;
  }

  private replaceJobInfo(job: Admin, navItems: FuseNavigationItem[]): void {
    navItems.forEach((n) => {
      if (n.id) {
        n.id = n.id.replace('{jobId}', job.adminId.toString());
      }
      if (n.link) {
        n.link = n.link.replace('{jobId}', job.adminId.toString());
      }
      if (n.title) {
        n.title = n.title.replace('{jobCode}', job.shortName);
      }
      if (n.subtitle) {
        n.subtitle = n.subtitle.replace('{jobName}', job.name);
      }
      if (n.children) {
        this.replaceJobInfo(job, n.children);
      }
    });
  }

  private getJobNavTemplate(includeGroupHeader: boolean): FuseNavigationItem[] {
    const navTemplate = [
      {
        id: 'group-job-{jobId}',
        type: 'group',
        title: '{jobCode}',
        subtitle: '{jobName}',
        classes: {
          title: 'text-2xl text-indigo-200',
        },
      },

      // {
      //   id: 'job.financial',
      //   title: 'Financial',
      //   type: 'basic',
      //   icon: regionVariantUtils.getCurrencySymbolCircleIcon(),
      //   link: '/apps/job/{jobId}/financial',
      // },
      // {
      //   id: 'job.documents',
      //   title: 'Documents',
      //   type: 'basic',
      //   icon: 'heroicons_outline:document-text',
      //   link: '/apps/job/{jobId}/documents',
      // },
      {
        id: 'time.reporting',
        title: 'Time Reporting',
        type: 'basic',
        icon: 'heroicons_outline:clock',
        link: '/apps/job/{jobId}/time',
      },
      {
        id: 'job.general',
        title: 'General',
        type: 'basic',
        icon: 'heroicons_outline:building-office',
        link: '/apps/job/{jobId}/general',
      },
    ];
    if (!includeGroupHeader) {
      navTemplate.shift();
    }
    return navTemplate as FuseNavigationItem[];
  }
}
